import { FaqContainer, IconosSliderComponent } from '@bpba/modules-components';
import { IIndexable } from '../model/IIndexable';
import { bannersMapping } from '../rest/bannersMapping';
import { iconosSliderMapping } from '../rest/iconosSliderMapping';
import { DestacadosComponent } from '../components/destacados/DestacadosComponent';
import { CatalogoComponent } from '../components/catalogo/CatalogoComponent';
import { productoDataMapping } from '../rest/productoDataMapping';
import { faqMapping } from '../rest/faqMapping';
import { NoveltiesWrapper } from '../components/novelties/NoveltiesWrapper';

export const mesumoDictionary: IIndexable = {
  modulo_banners: { component: NoveltiesWrapper, mapping: bannersMapping },
  iconos_slider: { component: IconosSliderComponent, mapping: iconosSliderMapping },
  mesumo_destacados: { component: DestacadosComponent, mapping: productoDataMapping },
  mesumo_catalogo: { component: CatalogoComponent, mapping: productoDataMapping },
  faqs: { component: FaqContainer, mapping: faqMapping },
};
